import React from 'react';
import WelcomeMessage from '../components/WelcomeMessage';
const Home = () => {
    return (
      <>
       <WelcomeMessage/>
      </>
    );
}

export default Home